(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    const hub = document.querySelector('[data-wipepedia-hub]');
    if (!hub) return;
    const guideSection = hub.querySelector('#wipepedia-guides');
    let grid = hub.querySelector('[data-wipepedia-grid]');
    const controls = [...hub.querySelectorAll('[data-wipepedia-filter]')];
    const setActive = (control) => controls.forEach((item) => item.classList.toggle('is-active', item.dataset.wipepediaFilter === control.dataset.wipepediaFilter));
    const replaceGuides = (document) => {
      const nextGrid = document.querySelector('[data-wipepedia-grid]');
      if (!nextGrid || !grid) return false;
      grid.innerHTML = nextGrid.innerHTML;
      const currentPagination = hub.querySelector('.wp2__pagination');
      const nextPagination = document.querySelector('.wp2__pagination');
      if (currentPagination) currentPagination.remove();
      if (nextPagination) grid.insertAdjacentHTML('afterend', nextPagination.outerHTML);
      return true;
    };
    const showLocalGuides = (filter) => {
      if (!grid) return;
      [...grid.querySelectorAll('[data-wipepedia-card]')].forEach((card) => {
        card.hidden = filter !== 'all' && !card.dataset.tags.includes(filter);
      });
    };
    controls.forEach((control) => control.addEventListener('click', async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const href = control.getAttribute('href') || '';
      const filter = control.dataset.wipepediaFilter;
      setActive(control);
      if (!href || href.startsWith('#')) {
        showLocalGuides(filter);
      } else {
        hub.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(href, { credentials: 'same-origin' });
          const markup = await response.text();
          const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
          if (response.ok && replaceGuides(nextDocument)) history.replaceState({}, '', href);
          else window.location.assign(href);
        } catch {
          window.location.assign(href);
        } finally {
          hub.removeAttribute('aria-busy');
        }
      }
      if (control.closest('.wp2__hero, .wp2__question-grid, .wp2__routines, .wp2__pillars')) guideSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
    hub.addEventListener('click', async (event) => {
      const pageLink = event.target.closest('.wp2__pagination a');
      if (!pageLink || !hub.contains(pageLink) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      hub.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(pageLink.href, { credentials: 'same-origin' });
        const markup = await response.text();
        const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
        if (response.ok && replaceGuides(nextDocument)) history.replaceState({}, '', pageLink.href);
        else window.location.assign(pageLink.href);
      } catch {
        window.location.assign(pageLink.href);
      } finally {
        hub.removeAttribute('aria-busy');
      }
    });
    const faqButtons = [...hub.querySelectorAll('[data-wipepedia-faq]')];
    const faqPanels = [...hub.querySelectorAll('[data-wipepedia-faq-panel]')];
    faqButtons.forEach((button) => button.addEventListener('click', () => {
      const target = button.dataset.wipepediaFaq;
      faqButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      faqPanels.forEach((panel) => { panel.hidden = panel.dataset.wipepediaFaqPanel !== target; });
    }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-custom"]) return;
  try {
    
  (() => {
    const initializeTarget = (target) => {
      if (target.dataset.pwFunnelInitialized === 'true') return;
      target.dataset.pwFunnelInitialized = 'true';

      const applyRecommendedInterval = () => {
        const recommendedInterval = target.dataset.pwDefaultInterval;
        const intervalSelect = target.querySelector('select[name="subs_interval"]');

        if (intervalSelect && recommendedInterval) {
          const matchingOption = Array.from(intervalSelect.options).find(
            (option) => option.textContent.trim() === recommendedInterval
          );

          if (matchingOption && intervalSelect.value !== matchingOption.value) {
            intervalSelect.value = matchingOption.value;
            intervalSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };

      const updateLoadedState = () => {
        if (target.querySelector('.sealsubs-container')) {
          target.classList.add('is-loaded');
          applyRecommendedInterval();
        }
      };

      const widgetObserver = new MutationObserver(updateLoadedState);
      widgetObserver.observe(target, { childList: true, subtree: true });
      updateLoadedState();
    };

    const purchaseZones = Array.from(
      document.querySelectorAll('.plush-subscription-guide, .plush-seal-widget-target, .product-form')
    );
    const visiblePurchaseZones = new Set();

    document.querySelectorAll('.plush-seal-widget-target').forEach(initializeTarget);

    if ('IntersectionObserver' in window && purchaseZones.length > 0) {
      const purchaseZoneObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              visiblePurchaseZones.add(entry.target);
            } else {
              visiblePurchaseZones.delete(entry.target);
            }
          });

          document.documentElement.classList.toggle(
            'pw-purchase-zone-visible',
            visiblePurchaseZones.size > 0
          );
        },
        { threshold: 0.08 }
      );

      purchaseZones.forEach((zone) => purchaseZoneObserver.observe(zone));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-botanical-duets"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.pwInitialized === 'true') return;

      const dataNode = root.querySelector('[data-pw-scents]');
      const scentImages = Array.from(root.querySelectorAll('.pw-botanical__scent-image'));
      const card = root.querySelector('.pw-botanical__scent-card');
      const state = root.querySelector('[data-pw-state]');
      const name = root.querySelector('[data-pw-name]');
      const description = root.querySelector('[data-pw-description]');
      const note = root.querySelector('[data-pw-image-note]');
      const progress = root.querySelector('[data-pw-progress]');
      const dots = root.querySelector('[data-pw-dots]');

      if (!dataNode || scentImages.length !== 2 || !card || !dots) return;

      let scents;
      try {
        scents = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      if (!Array.isArray(scents) || scents.length === 0) return;

      root.dataset.pwInitialized = 'true';
      let activeScentIndex = 0;
      let activeImageIndex = 0;
      let swapTimer;
      let ticking = false;
      const duetLabel = note.textContent.split('·')[0].trim();

      scents.forEach((scent) => {
        if (!scent.image) return;
        const preload = new Image();
        preload.src = scent.image;
      });

      const crossfadeImage = (scent) => {
        if (!scent.image) return;
        const previousIndex = activeImageIndex;
        const nextIndex = 1 - previousIndex;
        const previousImage = scentImages[previousIndex];
        const nextImage = scentImages[nextIndex];

        const reveal = () => {
          requestAnimationFrame(() => {
            nextImage.classList.add('is-active');
            previousImage.classList.remove('is-active');
            nextImage.removeAttribute('aria-hidden');
            previousImage.setAttribute('aria-hidden', 'true');
            activeImageIndex = nextIndex;
          });
        };

        nextImage.removeAttribute('srcset');
        nextImage.removeAttribute('sizes');
        nextImage.src = scent.image;
        nextImage.alt = scent.alt || scent.name;
        if (nextImage.complete) reveal();
        else nextImage.addEventListener('load', reveal, { once: true });
      };

      const setScent = (index) => {
        if (index === activeScentIndex || !scents[index]) return;
        activeScentIndex = index;
        const scent = scents[index];
        clearTimeout(swapTimer);
        crossfadeImage(scent);
        card.classList.add('is-leaving');

        swapTimer = window.setTimeout(() => {
          state.textContent = scent.state;
          name.textContent = scent.name;
          description.textContent = scent.description;
          note.textContent = `${duetLabel} · ${String(index + 1).padStart(2, '0')}`;
          progress.style.width = `${((index + 1) / scents.length) * 100}%`;
          root.style.setProperty('--pw-accent', scent.accent);
          dots.querySelectorAll('.pw-botanical__dot').forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === index);
          });
          requestAnimationFrame(() => card.classList.remove('is-leaving'));
        }, 300);
      };

      scents.forEach((scent, index) => {
        const button = document.createElement('button');
        button.className = `pw-botanical__dot${index === 0 ? ' is-active' : ''}`;
        button.type = 'button';
        button.setAttribute('aria-label', scent.name);
        button.addEventListener('click', () => {
          const sectionTop = root.getBoundingClientRect().top + window.scrollY;
          const destination = sectionTop + ((index + 0.22) / scents.length) * (root.offsetHeight - window.innerHeight);
          window.scrollTo({ top: destination, behavior: 'smooth' });
        });
        dots.appendChild(button);
      });

      const updateFromScroll = () => {
        const sectionTop = root.getBoundingClientRect().top + window.scrollY;
        const max = root.offsetHeight - window.innerHeight;
        const sectionProgress = Math.min(1, Math.max(0, (window.scrollY - sectionTop) / Math.max(1, max)));
        setScent(Math.min(scents.length - 1, Math.floor(sectionProgress * scents.length)));
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateFromScroll();
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', updateFromScroll, { passive: true });
      root.pwCleanup = () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', updateFromScroll);
      };
      updateFromScroll();
    };

    document.querySelectorAll('[data-pw-botanical]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-pw-botanical]') || event.target.closest('[data-pw-botanical]'));
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('[data-pw-botanical]') || event.target.closest('[data-pw-botanical]');
      if (root && root.pwCleanup) root.pwCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-five-trips-landing-v03"] && !Shopify.designMode) return;
  try {
    
  (()=>{const root=document.querySelector('[data-ftl-root]');if(!root)return;const variants=[...root.querySelectorAll('[data-ftl-variant]')];const image=root.querySelector('[data-ftl-offer-image]');const link=root.querySelector('[data-ftl-shop-link]');const name=root.querySelector('[data-ftl-shop-name]');const select=(button)=>{variants.forEach(item=>{const active=item===button;item.classList.toggle('is-selected',active);item.setAttribute('aria-pressed',String(active))});image.src=button.dataset.image;image.alt=button.dataset.alt;link.href=button.dataset.url;name.textContent=button.dataset.name;if(window.dataLayer)window.dataLayer.push({event:'ftl_variant_select',ftl_variant:button.dataset.name})};variants.forEach(button=>button.addEventListener('click',()=>select(button)));root.querySelectorAll('[data-ftl-card]').forEach(card=>card.addEventListener('click',()=>{const button=variants[Number(card.dataset.ftlCard)];select(button);root.querySelector('#ftl-shop').scrollIntoView({behavior:'smooth'})}));link.addEventListener('click',()=>{if(window.dataLayer)window.dataLayer.push({event:'ftl_shop_click',ftl_variant:name.textContent})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-homepage-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pwh-root]');
    roots.forEach((root) => {
      if (root.dataset.pwhReady === 'true') return;
      root.dataset.pwhReady = 'true';

      const revealNodes = root.querySelectorAll('[data-pwh-reveal]');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('is-visible', entry.isIntersecting));
        }, { threshold: 0.14 });
        revealNodes.forEach((node) => observer.observe(node));
      } else {
        revealNodes.forEach((node) => node.classList.add('is-visible'));
      }

      const momentsNode = root.querySelector('[data-pwh-moments-json]');
      if (momentsNode) {
        const moments = JSON.parse(momentsNode.textContent);
        const image = root.querySelector('[data-pwh-moment-image]');
        const label = root.querySelector('[data-pwh-moment-label]');
        const title = root.querySelector('[data-pwh-moment-title]');
        const copy = root.querySelector('[data-pwh-moment-copy]');
        const tabs = root.querySelectorAll('[data-pwh-moment-index]');
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const index = Number(tab.dataset.pwhMomentIndex);
            const moment = moments[index];
            if (!moment) return;
            image.src = moment.image;
            image.alt = `${moment.label} private-care setting`;
            label.textContent = moment.label;
            title.textContent = moment.heading;
            copy.textContent = moment.description;
            tabs.forEach((item, itemIndex) => {
              const active = itemIndex === index;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-selected', String(active));
            });
          });
        });
      }

      const fragrance = root.querySelector('[data-pwh-fragrance]');
      const scentsNode = root.querySelector('[data-pwh-scents-json]');
      if (fragrance && scentsNode) {
        const scents = JSON.parse(scentsNode.textContent);
        const images = fragrance.querySelectorAll('.pwh-fragrance__image');
        const name = fragrance.querySelector('[data-pwh-scent-name]');
        const description = fragrance.querySelector('[data-pwh-scent-description]');
        const controls = fragrance.querySelectorAll('[data-pwh-scent-index]');
        let activeIndex = -1;

        const setScent = (index) => {
          if (!scents[index] || activeIndex === index) return;
          activeIndex = index;
          name.textContent = scents[index].name;
          description.textContent = scents[index].description;
          images.forEach((imageNode, imageIndex) => imageNode.classList.toggle('is-active', imageIndex === index));
          controls.forEach((control, controlIndex) => control.classList.toggle('is-active', controlIndex === index));
        };

        const updateFromScroll = () => {
          const rect = fragrance.getBoundingClientRect();
          const maximum = fragrance.offsetHeight - window.innerHeight;
          const progress = Math.min(.999, Math.max(0, -rect.top / Math.max(maximum, 1)));
          setScent(Math.floor(progress * scents.length));
        };

        controls.forEach((control) => {
          control.addEventListener('click', () => {
            const index = Number(control.dataset.pwhScentIndex);
            const maximum = fragrance.offsetHeight - window.innerHeight;
            const denominator = Math.max(scents.length - 1, 1);
            window.scrollTo({ top: fragrance.offsetTop + (index / denominator) * maximum, behavior: 'smooth' });
          });
        });

        window.addEventListener('scroll', updateFromScroll, { passive: true });
        updateFromScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-pdp-exact-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)}`;
    const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[character]);

    const initialize = (root) => {
      if (root.dataset.pwInitialized === 'true') return;
      root.dataset.pwInitialized = 'true';

      const find = (role) => root.querySelector(`[data-role="${role}"]`);
      const config = JSON.parse(find('pdp-config')?.textContent || 'null');
      const product = JSON.parse(find('product-json')?.textContent || 'null');
      const routes = JSON.parse(find('pdp-routes')?.textContent || '{}');
      if (!config || !product || !config.states?.length) return;

      const initialVariantId = Number(root.dataset.selectedVariantId);
      const initialVariant = product.variants.find((variant) => Number(variant.id) === initialVariantId) || product.variants[0];
      const optionNames = product.options.map((option) => typeof option === 'string' ? option : option.name);
      const normalizeOption = (value) => String(value || '').trim().toLowerCase();
      const scentOptionIndex = optionNames.findIndex((name) => /scent|fragrance/i.test(name));
      const packOptionIndex = optionNames.findIndex((name) => /quantity|format|size/i.test(name));
      const initialScent = scentOptionIndex >= 0 ? initialVariant?.options?.[scentOptionIndex] : config.states[0].scent;
      const initialSku = config.states.find((item) => item.scent === initialScent) || config.states[0];
      const initialPackLabel = packOptionIndex >= 0 ? initialVariant?.options?.[packOptionIndex] : initialVariant?.options?.[0];
      const initialPackIndex = Math.max(0, config.line.packs.findIndex((pack) => normalizeOption(pack[0]) === normalizeOption(initialPackLabel)));

      const state = {
        sku: initialSku,
        pack: initialPackIndex,
        purchase: 'once',
        qty: 1,
        image: 0,
        sellingPlanId: null,
        busy: false
      };

      const plans = product.selling_plan_groups?.flatMap((group) => group.selling_plans || []) || [];
      state.sellingPlanId = plans[0]?.id || null;

      const setImageSource = (image, url, alt) => {
        if (!image || !url) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
        if (alt !== undefined) image.alt = alt;
      };

      const variantForState = () => product.variants.find((variant) => {
        const scentMatches = scentOptionIndex < 0 || normalizeOption(variant.options?.[scentOptionIndex]) === normalizeOption(state.sku.scent);
        let packMatches = true;
        if (packOptionIndex >= 0) packMatches = normalizeOption(variant.options?.[packOptionIndex]) === normalizeOption(config.line.packs[state.pack][0]);
        if (packOptionIndex < 0 && product.options.length === 1) packMatches = normalizeOption(variant.options?.[0]) === normalizeOption(config.line.packs[state.pack][0]);
        return scentMatches && packMatches;
      });

      const orderedGallery = () => {
        const primary = state.sku.primaryByPack[state.pack] || state.sku.gallery[0];
        return [primary, ...state.sku.gallery.filter((url) => url !== primary)];
      };

      const pricing = () => {
        const variant = variantForState();
        const fallback = Math.round(Number(config.line.packs[state.pack][2]) * 100);
        const base = Number(variant?.price || fallback);
        const allocation = variant?.selling_plan_allocations?.find((item) => Number(item.selling_plan_id) === Number(state.sellingPlanId));
        const subscription = Number(allocation?.price || Math.round(base * 0.9));
        return { base, subscription, selected: state.purchase === 'subscribe' ? subscription : base };
      };

      const isPurchasable = () => {
        const variant = variantForState();
        return Boolean(variant && variant.available && !state.sku.comingSoon);
      };

      const showToast = (message) => {
        const toast = find('toast');
        toast.textContent = message;
        toast.classList.add('visible');
        window.clearTimeout(showToast.timer);
        showToast.timer = window.setTimeout(() => toast.classList.remove('visible'), 2600);
      };

      const syncGalleryScrollButtons = () => {
        const thumbs = find('gallery-thumbs');
        const previous = root.querySelector('[data-action="gallery-scroll-prev"]');
        const next = root.querySelector('[data-action="gallery-scroll-next"]');
        if (!thumbs || !previous || !next) return;
        const end = Math.max(0, thumbs.scrollWidth - thumbs.clientWidth);
        previous.disabled = thumbs.scrollLeft <= 2;
        next.disabled = thumbs.scrollLeft >= end - 2;
      };

      const moveGalleryRail = (direction) => {
        const thumbs = find('gallery-thumbs');
        if (!thumbs) return;
        const distance = Math.max(210, Math.round(thumbs.clientWidth * 0.72));
        thumbs.scrollBy({ left: direction * distance, behavior: 'smooth' });
        window.setTimeout(syncGalleryScrollButtons, 260);
      };

      const updateDialogImage = () => {
        const dialog = find('image-dialog');
        if (!dialog) return;
        const gallery = orderedGallery();
        const image = gallery[state.image] || gallery[0];
        setImageSource(find('dialog-image'), image, find('main-image')?.alt || '');
        find('dialog-count').textContent = `Image ${state.image + 1} of ${gallery.length}`;
      };

      const updateCartBubble = async () => {
        try {
          const response = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child').forEach((node) => {
            node.textContent = cart.item_count;
          });
        } catch (_) {
          // The cart addition remains successful even if a theme-specific bubble cannot refresh.
        }
      };

      const render = () => {
        const sku = state.sku;
        const line = config.line;
        const packs = line.packs;
        const gallery = orderedGallery();
        const currentImage = gallery[state.image] || gallery[0];
        const variant = variantForState();
        const prices = pricing();
        const purchasable = isPurchasable();
        root.style.setProperty('--accent', sku.swatch);
        find('line-eyebrow').textContent = line.label;
        find('product-title').textContent = line.title;
        find('scent-title').textContent = sku.scent;
        find('lead').textContent = sku.lead;
        setImageSource(find('main-image'), currentImage, `${line.title}, ${sku.scent}, purchase gallery image ${state.image + 1}`);
        find('gallery-thumbs').innerHTML = gallery.map((url, index) => `
          <button class="${index === state.image ? 'active' : ''}" type="button" data-image="${index}" aria-label="View purchase image ${index + 1}" aria-current="${index === state.image ? 'true' : 'false'}">
            <img src="${escapeHtml(url)}" alt="" width="180" height="180" loading="lazy">
          </button>
        `).join('');
        window.requestAnimationFrame(() => {
          const activeThumb = find('gallery-thumbs')?.querySelector('.active');
          activeThumb?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          syncGalleryScrollButtons();
        });

        find('selected-scent').textContent = sku.scent;
        find('scent-choices').innerHTML = config.states.map((item) => `
          <button class="choice ${item.id === sku.id ? 'active' : ''}" type="button" data-sku="${escapeHtml(item.id)}" style="--swatch:${escapeHtml(item.swatch)}">
            <i class="swatch"></i>
            <span>${escapeHtml(item.scent)}</span>
            <small>${item.comingSoon ? 'Coming soon' : 'Available now'}</small>
          </button>
        `).join('');

        find('selected-pack').textContent = `${packs[state.pack][0]} · ${packs[state.pack][1]}`;
        find('pack-choices').innerHTML = packs.map((pack, index) => `
          <button class="choice ${index === state.pack ? 'active' : ''}" type="button" data-pack="${index}">
            <span>${escapeHtml(pack[0])}</span>
            <small>${escapeHtml(pack[1])} · ${money(Math.round(Number(pack[2]) * 100))}</small>
          </button>
        `).join('');

        find('price').textContent = `From ${money(Math.round(Number(packs[0][2]) * 100))}`;
        find('price-note').textContent = sku.comingSoon ? 'Price parity with Go Fragrance Free' : 'USD · taxes calculated at checkout';
        find('once-price').textContent = money(prices.base);
        find('sub-price').textContent = money(prices.subscription);
        root.querySelectorAll(`input[name="purchase-${root.dataset.sectionId}"]`).forEach((radio) => {
          radio.checked = radio.value === state.purchase;
        });

        const frequency = find('frequency');
        frequency.classList.toggle('visible', state.purchase === 'subscribe');
        const frequencySelect = find('frequency-select');
        frequencySelect.innerHTML = plans.map((plan) => {
          const label = plan.options?.[0]?.value || plan.name;
          return `<option value="${plan.id}" ${Number(plan.id) === Number(state.sellingPlanId) ? 'selected' : ''}>${escapeHtml(label)}</option>`;
        }).join('');

        find('qty').textContent = state.qty;
        find('quantity-input').value = state.qty;
        find('variant-id').value = variant?.id || '';
        const addButton = root.querySelector('[data-action="add"]');
        addButton.textContent = sku.comingSoon
          ? `Coming soon · ${money(prices.selected * state.qty)}`
          : `${purchasable ? 'Add to bag' : 'Unavailable'} · ${money(prices.selected * state.qty)}`;
        addButton.disabled = !purchasable || state.busy;
        find('cart-note').textContent = sku.comingSoon
          ? 'Coming soon. Specifications and pricing match Go Fragrance Free; ordering will open when it is ready to ship.'
          : 'Subscribe & Save renews at the selected frequency; skip, pause or cancel anytime.';

        find('trust-one').textContent = line.trust[0];
        find('trust-two').textContent = line.trust[1];
        find('trust-three').textContent = line.trust[2];
        setImageSource(find('aplus-image'), sku.aplus, `${line.title} ${sku.scent} resting naturally in a brand-aligned editorial setting`);
        find('aplus-eyebrow').textContent = sku.aplusEyebrow;
        find('aplus-title').textContent = sku.aplusTitle;
        find('aplus-copy').textContent = sku.aplusCopy;
        find('aplus-note').innerHTML = `<strong>${escapeHtml(sku.noteTitle)}</strong><span>${escapeHtml(sku.note)}</span>`;

        find('features-title').textContent = line.featuresTitle;
        find('feature-grid').innerHTML = line.features.map((feature, index) => `
          <article><span>0${index + 1}</span><h3>${escapeHtml(feature[0])}</h3><p>${escapeHtml(feature[1])}</p></article>
        `).join('');
        find('facts-list').innerHTML = line.facts.map((fact) => `
          <div><dt>${escapeHtml(fact[0])}</dt><dd>${escapeHtml(fact[1])}</dd></div>
        `).join('');
        find('faq-list').innerHTML = sku.faq.map((item) => `
          <details><summary>${escapeHtml(item[0])}</summary><p>${escapeHtml(item[1])}</p></details>
        `).join('');

        find('mobile-title').textContent = `${line.nav} · ${sku.scent}`;
        find('mobile-price').textContent = money(prices.selected);
        const mobileButton = root.querySelector('[data-action="mobile-add"]');
        mobileButton.textContent = sku.comingSoon ? 'Coming soon' : purchasable ? 'Add to bag' : 'Unavailable';
        mobileButton.disabled = !purchasable || state.busy;

        if (variant?.id) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };

      const addToCart = async () => {
        const variant = variantForState();
        if (!variant || !isPurchasable() || state.busy) return;
        state.busy = true;
        render();
        const payload = { items: [{ id: variant.id, quantity: state.qty }] };
        if (state.purchase === 'subscribe' && state.sellingPlanId) payload.items[0].selling_plan = state.sellingPlanId;
        try {
          const response = await fetch(routes.cartAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
          showToast('Added to bag.');
          await updateCartBubble();
        } catch (error) {
          showToast(error.message || 'Unable to add this item.');
        } finally {
          state.busy = false;
          render();
        }
      };

      root.addEventListener('click', (event) => {
        const skuButton = event.target.closest('[data-sku]');
        if (skuButton) {
          state.sku = config.states.find((item) => item.id === skuButton.dataset.sku) || state.sku;
          state.pack = 0;
          state.qty = 1;
          state.image = 0;
          render();
          return;
        }
        const packButton = event.target.closest('[data-pack]');
        if (packButton) {
          state.pack = Number(packButton.dataset.pack);
          state.image = 0;
          render();
          return;
        }
        const imageButton = event.target.closest('[data-image]');
        if (imageButton) {
          state.image = Number(imageButton.dataset.image);
          render();
          return;
        }
        if (event.target.closest('[data-action="gallery-scroll-prev"]')) {
          moveGalleryRail(-1);
          return;
        }
        if (event.target.closest('[data-action="gallery-scroll-next"]')) {
          moveGalleryRail(1);
          return;
        }
        if (event.target.closest('[data-action="qty-minus"]')) {
          state.qty = Math.max(1, state.qty - 1);
          render();
        }
        if (event.target.closest('[data-action="qty-plus"]')) {
          state.qty += 1;
          render();
        }
        if (event.target.closest('[data-action="mobile-add"]')) addToCart();
        if (event.target.closest('.gallery__zoom')) {
          const dialog = find('image-dialog');
          updateDialogImage();
          dialog.showModal();
        }
        if (event.target.closest('[data-action="dialog-close"]')) find('image-dialog').close();
        if (event.target.closest('[data-action="dialog-prev"]')) {
          const gallery = orderedGallery();
          state.image = (state.image - 1 + gallery.length) % gallery.length;
          render();
          updateDialogImage();
        }
        if (event.target.closest('[data-action="dialog-next"]')) {
          const gallery = orderedGallery();
          state.image = (state.image + 1) % gallery.length;
          render();
          updateDialogImage();
        }
      });

      root.querySelector('.pw-product-form')?.addEventListener('submit', (event) => {
        event.preventDefault();
        addToCart();
      });
      root.querySelectorAll(`input[name="purchase-${root.dataset.sectionId}"]`).forEach((radio) => {
        radio.addEventListener('change', () => {
          state.purchase = radio.value;
          render();
        });
      });
      find('frequency-select')?.addEventListener('change', (event) => {
        state.sellingPlanId = Number(event.target.value);
        render();
      });
      find('gallery-thumbs')?.addEventListener('scroll', syncGalleryScrollButtons, { passive: true });
      find('gallery-thumbs')?.addEventListener('wheel', (event) => {
        const thumbs = find('gallery-thumbs');
        if (!thumbs || thumbs.scrollWidth <= thumbs.clientWidth) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        thumbs.scrollLeft += event.deltaY;
        syncGalleryScrollButtons();
      }, { passive: false });
      find('image-dialog')?.addEventListener('click', (event) => {
        if (event.target === find('image-dialog')) find('image-dialog').close();
      });
      find('image-dialog')?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          root.querySelector('[data-action="dialog-prev"]')?.click();
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          root.querySelector('[data-action="dialog-next"]')?.click();
        }
      });

      render();
    };

    const initializeAll = () => document.querySelectorAll('[data-pw-pdp]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initializeHero = (hero) => {
      if (!hero || hero.dataset.pwVideoReady === 'true') return;
      hero.dataset.pwVideoReady = 'true';

      const desktopVideo = hero.querySelector('.pw-video-hero__video--desktop');
      const mobileVideo = hero.querySelector('.pw-video-hero__video--mobile');
      const control = hero.querySelector('[data-pw-video-control]');
      let manuallyPaused = false;

      const activeVideo = () => (mobileQuery.matches ? mobileVideo : desktopVideo) || desktopVideo || mobileVideo;

      const syncPlayback = () => {
        const currentVideo = activeVideo();
        [desktopVideo, mobileVideo].forEach((video) => {
          if (video && video !== currentVideo) video.pause();
        });

        if (!currentVideo || reducedMotionQuery.matches || manuallyPaused) {
          if (currentVideo) currentVideo.pause();
          return;
        }

        currentVideo.muted = true;
        currentVideo.play().catch(() => {
          manuallyPaused = true;
          if (control) control.setAttribute('aria-pressed', 'true');
        });
      };

      if (control) {
        control.addEventListener('click', () => {
          manuallyPaused = !manuallyPaused;
          control.setAttribute('aria-pressed', String(manuallyPaused));
          syncPlayback();
        });
      }

      mobileQuery.addEventListener('change', syncPlayback);
      reducedMotionQuery.addEventListener('change', syncPlayback);
      syncPlayback();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-pw-video-hero]').forEach(initializeHero);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wipepedia-hub-refresh"]) return;
  try {
    
  (() => {
    const hub = document.querySelector('[data-wipepedia-hub]');
    if (!hub) return;
    const guideSection = hub.querySelector('#wipepedia-guides');
    let grid = hub.querySelector('[data-wipepedia-grid]');
    const controls = [...hub.querySelectorAll('[data-wipepedia-filter]')];
    const setActive = (control) => controls.forEach((item) => item.classList.toggle('is-active', item.dataset.wipepediaFilter === control.dataset.wipepediaFilter));
    const replaceGuides = (document) => {
      const nextGrid = document.querySelector('[data-wipepedia-grid]');
      if (!nextGrid || !grid) return false;
      grid.innerHTML = nextGrid.innerHTML;
      const currentPagination = hub.querySelector('.wp2__pagination');
      const nextPagination = document.querySelector('.wp2__pagination');
      if (currentPagination) currentPagination.remove();
      if (nextPagination) grid.insertAdjacentHTML('afterend', nextPagination.outerHTML);
      return true;
    };
    const showLocalGuides = (filter) => {
      if (!grid) return;
      [...grid.querySelectorAll('[data-wipepedia-card]')].forEach((card) => {
        card.hidden = filter !== 'all' && !card.dataset.tags.includes(filter);
      });
    };
    controls.forEach((control) => control.addEventListener('click', async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const href = control.getAttribute('href') || '';
      const filter = control.dataset.wipepediaFilter;
      setActive(control);
      if (!href || href.startsWith('#')) {
        showLocalGuides(filter);
      } else {
        hub.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(href, { credentials: 'same-origin' });
          const markup = await response.text();
          const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
          if (response.ok && replaceGuides(nextDocument)) history.replaceState({}, '', href);
          else window.location.assign(href);
        } catch {
          window.location.assign(href);
        } finally {
          hub.removeAttribute('aria-busy');
        }
      }
      if (control.closest('.wp2__hero, .wp2__question-grid, .wp2__routines, .wp2__pillars')) guideSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
    hub.addEventListener('click', async (event) => {
      const pageLink = event.target.closest('.wp2__pagination a');
      if (!pageLink || !hub.contains(pageLink) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      hub.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(pageLink.href, { credentials: 'same-origin' });
        const markup = await response.text();
        const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
        if (response.ok && replaceGuides(nextDocument)) history.replaceState({}, '', pageLink.href);
        else window.location.assign(pageLink.href);
      } catch {
        window.location.assign(pageLink.href);
      } finally {
        hub.removeAttribute('aria-busy');
      }
    });
    const faqButtons = [...hub.querySelectorAll('[data-wipepedia-faq]')];
    const faqPanels = [...hub.querySelectorAll('[data-wipepedia-faq-panel]')];
    faqButtons.forEach((button) => button.addEventListener('click', () => {
      const target = button.dataset.wipepediaFaq;
      faqButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      faqPanels.forEach((panel) => { panel.hidden = panel.dataset.wipepediaFaqPanel !== target; });
    }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wipepedia-hub"]) return;
  try {
    
  (() => {
    const hub = document.querySelector('[data-wipepedia-hub]');
    if (!hub) return;
    const guideSection = hub.querySelector('#wipepedia-guides');
    let grid = hub.querySelector('[data-wipepedia-grid]');
    const controls = [...hub.querySelectorAll('[data-wipepedia-filter]')];
    const setActive = (control) => controls.forEach((item) => item.classList.toggle('is-active', item.dataset.wipepediaFilter === control.dataset.wipepediaFilter));
    const replaceGuides = (document) => {
      const nextGrid = document.querySelector('[data-wipepedia-grid]');
      if (!nextGrid || !grid) return false;
      grid.innerHTML = nextGrid.innerHTML;
      const currentPagination = hub.querySelector('.wp2__pagination');
      const nextPagination = document.querySelector('.wp2__pagination');
      if (currentPagination) currentPagination.remove();
      if (nextPagination) grid.insertAdjacentHTML('afterend', nextPagination.outerHTML);
      return true;
    };
    const showLocalGuides = (filter) => {
      if (!grid) return;
      [...grid.querySelectorAll('[data-wipepedia-card]')].forEach((card) => {
        card.hidden = filter !== 'all' && !card.dataset.tags.includes(filter);
      });
    };
    controls.forEach((control) => control.addEventListener('click', async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const href = control.getAttribute('href') || '';
      const filter = control.dataset.wipepediaFilter;
      setActive(control);
      if (!href || href.startsWith('#')) {
        showLocalGuides(filter);
      } else {
        hub.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(href, { credentials: 'same-origin' });
          const markup = await response.text();
          const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
          if (response.ok && replaceGuides(nextDocument)) history.replaceState({}, '', href);
          else window.location.assign(href);
        } catch {
          window.location.assign(href);
        } finally {
          hub.removeAttribute('aria-busy');
        }
      }
      if (control.closest('.wp2__hero, .wp2__question-grid, .wp2__routines, .wp2__pillars')) guideSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
    hub.addEventListener('click', async (event) => {
      const pageLink = event.target.closest('.wp2__pagination a');
      if (!pageLink || !hub.contains(pageLink) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      hub.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(pageLink.href, { credentials: 'same-origin' });
        const markup = await response.text();
        const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
        if (response.ok && replaceGuides(nextDocument)) history.replaceState({}, '', pageLink.href);
        else window.location.assign(pageLink.href);
      } catch {
        window.location.assign(pageLink.href);
      } finally {
        hub.removeAttribute('aria-busy');
      }
    });
    const faqButtons = [...hub.querySelectorAll('[data-wipepedia-faq]')];
    const faqPanels = [...hub.querySelectorAll('[data-wipepedia-faq-panel]')];
    faqButtons.forEach((button) => button.addEventListener('click', () => {
      const target = button.dataset.wipepediaFaq;
      faqButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      faqPanels.forEach((panel) => { panel.hidden = panel.dataset.wipepediaFaqPanel !== target; });
    }));
  })();

  } catch(e) { console.error(e); }
})();
})();
